export const maintenanceAmendmentOfTermsApplication = {
  headerTitle: {
    nb: 'Endring av vilkår for lån/tilskudd',
    nn: 'Endring av vilkår for lån/tilskot',
    en: 'Change of terms for loan/grant',
  },
  summaryTitle: {
    nb: 'Oppsummering og innsending',
    nn: 'Oppsummering og innsending',
    en: 'Summary and submission',
  },
  confirmSectionTitle: {
    nb: 'Bekreft før innsending',
    nn: 'Stadfest før innsending',
    en: 'Confirm before submission',
  },
  confirmCheckbox1: {
    nb: 'Jeg bekrefter at disse opplysningene stemmer',
    nn: 'Eg stadfestar at desse opplysningane er riktige',
    en: 'I confirm that this information is correct',
  },
  confirmCheckbox2: {
    nb: 'Jeg bekrefter at jeg har lest og er kjent med Innovasjon Norges betingelser og vilkår for denne søknaden',
    nn: 'Eg stadfestar at eg har lese og er kjent med Innovasjon Noreg sine vilkår og betingingar for denne søknaden',
    en: 'I confirm that I have read and am familiar with Innovation Norway’s terms and conditions for this application',
  },
  descriptionTitle: {
    nb: 'Om søknaden',
    nn: 'Om søknaden',
    en: 'About the application',
  },
  descriptionPart1: {
    nb: 'Dersom du planlegger vesentlige endringer som berører engasjementet med Innovasjon Norge, må Innovasjon Norge gi sitt samtykke før endringene gjennomføres.',
    nn: 'Dersom du planlegg vesentlege endringar som påverkar engasjementet med Innovasjon Noreg, må Innovasjon Noreg gje sitt samtykke før endringane vert gjennomførte.',
    en: 'If you are planning significant changes that affect the engagement with Innovation Norway, Innovation Norway must give its consent before the changes are implemented.',
  },
  descriptionPart2: {
    nb: 'Denne søknaden benyttes dersom det søkes om endring av vilkår eller særvilkår knyttet til lån eller tilskudd.',
    nn: 'Denne søknaden blir brukt dersom det blir søkt om endring av vilkår eller særvilkår knytt til lån eller tilskot.',
    en: 'This application is used when applying for changes to terms or special conditions related to loans or grants.',
  },
  descriptionPart3: {
    nb: 'For avdragsutsettelse, prioritetsvikelse, endring av sikkerheter eller debitor brukes eget skjema.',
    nn: 'For avdragsutsetjing, prioritetsvik, endring av tryggleikar eller debitor blir eige skjema brukt.',
    en: 'For deferral of installments, priority waiver, changes to securities or debtor, a separate form is used.',
  },
  descriptionPart4: {
    nb: 'Forsinkelsesrenter vil bli beregnet. Ved behandling av søknaden fra virksomheten har Innovasjon Norge anledning til å innhente kredittopplysninger.',
    nn: 'Forsinkingsrenter vil bli rekna ut. Ved behandling av søknaden frå verksemda har Innovasjon Noreg høve til å hente inn kredittopplysningar.',
    en: 'Late payment interest will be calculated. When processing the application from the business, Innovation Norway has the right to obtain credit information.',
  },
  changeFeeTitle: {
    nb: 'Endringsgebyr',
    nn: 'Endringsgebyr',
    en: 'Change fee',
  },
  changeFeeDescription: {
    nb: 'Behandling av en endringssøknad medfører en kostnad fra 1250,- NOK per konto. I de tilfeller kostnaden blir høyere enn 1250,- NOK vil du bli kontaktet av Innovasjon Norge med informasjon om størrelse på gebyr. Du vil da måtte godkjenne dette gebyret før vi behandler saken. Gebyr vil fremkomme i vedtaksbrevet, og effektueres ved neste faktura.',
    nn: 'Behandling av ein endringssøknad medfører ein kostnad frå 1250,- NOK per konto. Dersom kostnaden blir høgare enn 1250,- NOK, vil du bli kontakta av Innovasjon Noreg med informasjon om storleiken på gebyret. Du må då godkjenne dette gebyret før vi behandlar saka. Gebyret vil stå i vedtaksbrevet og bli fakturert ved neste faktura.',
    en: 'Processing a change application incurs a fee starting from NOK 1250 per account. If the fee exceeds NOK 1250, you will be contacted by Innovation Norway with information about the fee amount. You must then approve the fee before we process the case. The fee will be stated in the decision letter and applied to the next invoice.',
  },
  customerDetails: {
    nb: 'Kundedetaljer',
    nn: 'Kundedetaljar',
    en: 'Customer details',
  },
  customer: {
    nb: 'Kunde',
    nn: 'Kunde',
    en: 'Customer',
  },
  organizationNumber: {
    nb: 'Organisasjonsnummer',
    nn: 'Organisasjonsnummer',
    en: 'Organization Number',
  },
  downloadAndFillOutTheApplicationFormTitle: {
    nb: 'Last ned og fyll ut søknadsskjema',
    nn: 'Last ned og fyll ut søknadsskjemaet',
    en: 'Download and complete the application form',
  },
  downloadAndFillOutTheApplicationFormDescription: {
    nb: 'Fyll ut søknadsskjemaet før du laster det opp igjen på neste steg.',
    nn: 'Fyll ut søknadsskjemaet før du lastar det opp igjen i neste steg.',
    en: 'Fill out the application form before uploading it in the next step.',
  },
  signatureRightsTitle: {
    nb: 'Signaturrett',
    nn: 'Signaturrett',
    en: 'Signing authority',
  },
  signatureRightsDescription: {
    nb: 'Oppgi e-postadressen til personen som har signaturrett for virksomheten. Du kan søke opp virksomheten hos {0} for å se hvem som har signaturrett.',
    nn: 'Oppgi e-postadressa til personen som har signaturrett for verksemda. Du kan søkje opp verksemda hos {0} for å sjå kven som har signaturrett.',
    en: 'Provide the email address of the person who has signing authority for the organization. You can look up the organization in the {0} to see who has signing authority.',
  },
  signatureRightsLink: {
    nb: 'Brønnøysundregistrene',
    nn: 'Brønnøysundregistera',
    en: 'Brønnøysund Register Centre',
  },
  authorizedSignatoryLabel: {
    nb: 'E-postadresse til signaturberettiget',
    nn: 'E-postadresse til signaturberettiga',
    en: 'Email address of authorized signatory',
  },
  authorizedSignatoryLabelError: {
    nb: 'Du må oppgi en gyldig e-postadresse til personen som har signaturrett for virksomheten.',
    nn: 'Du må oppgi ei gyldig e-postadresse til personen som har signeringsrett for verksemda.',
    en: 'You must provide a valid email address for the person authorized to sign on behalf of the organization.',
  },
  delete: {
    nb: 'Slett',
    nn: 'Slett',
    en: 'Delete',
  },
  titleAttachmentPage: {
    nb: 'Vedlegg',
    nn: 'Vedlegg',
    en: 'Attachments',
  },
  summaryAttachmentPage: {
    nb: 'Du kan laste opp følgende filtyper: .pdf, .docx, .xlsx, .odt og .ods',
    nn: 'Du kan laste opp følgjande filtypar: .pdf, .docx, .xlsx, .odt og .ods',
    en: 'You can upload the following file types: .pdf, .docx, .xlsx, .odt, and .ods',
  },
  applicationForm: {
    nb: 'Last opp utfylt søknadsskjema',
    nn: 'Last opp utfylt søknadsskjema',
    en: 'Upload completed application form',
  },
  applicationFormHelpText: {
    nb: 'Fyll ut og last opp søknadsskjemaet du lastet ned på forrige steg.',
    nn: 'Fyll ut og last opp søknadsskjemaet du lasta ned i førre steg.',
    en: 'Fill out and upload the application form you downloaded in the previous step.',
  },
  interimAccountForm: {
    nb: 'Perioderegnskap',
    nn: 'Perioderekneskap',
    en: 'Interim financial statement',
  },
  interimAccountFormHelpText: {
    nb: 'Legg ved foreløpig resultat og balanse for inneværende år',
    nn: 'Legg ved førebels resultat og balanse for inneverande år',
    en: 'Attach preliminary profit and balance sheet for the current year',
  },
  otherInformation: {
    nb: 'Andre opplysninger',
    nn: 'Andre opplysningar',
    en: 'Other information',
  },
  noInfoGiven: {
    nb: 'Ingen opplysninger gitt.',
    nn: 'Ingen opplysningar gitt.',
    en: 'No information given.',
  },
  termsAndConditionsTitle: {
    nb: 'Betingelser og vilkår',
    nn: 'Betingingar og vilkår',
    en: 'Terms and conditions',
  },
  termsAndConditionsDescriptionPart1: {
    nb: 'Ved behandling av søknaden kan Innovasjon Norge hente inn informasjon fra banken din om ditt kundeforhold der.',
    nn: 'Ved handsaming av søknaden kan Innovasjon Noreg hente inn informasjon frå banken din om ditt kundeforhold der.',
    en: 'When processing the application, Innovation Norway may collect information from your bank about your customer relationship there.',
  },
  termsAndConditionsDescriptionPart2: {
    nb: 'Forsinkelsesrenter vil bli beregnet. Ved behandling av søknaden fra virksomheten har Innovasjon Norge anledning til å innhente kredittopplysninger.',
    nn: 'Forsinkingsrenter vil bli rekna ut. Ved behandling av søknaden frå verksemda har Innovasjon Noreg høve til å hente inn kredittopplysningar.',
    en: 'Late payment interest will be calculated. When processing the application from the business, Innovation Norway may obtain credit information.',
  },
  termsAndConditionsDescriptionPart3: {
    nb: 'Behandling av en endringssøknad medfører en kostnad fra 1250,- NOK per konto. I de tilfeller kostnaden blir høyere enn 1250,- NOK vil du bli kontaktet av Innovasjon Norge med informasjon om størrelse på gebyr.',
    nn: 'Behandling av ein endringssøknad medfører ein kostnad frå 1250,- NOK per konto. Dersom kostnaden blir høgare enn 1250,- NOK, vil du bli kontakta av Innovasjon Noreg med informasjon om storleiken på gebyret.',
    en: 'Processing a change application involves a fee starting from NOK 1250 per account. If the fee exceeds NOK 1250, you will be contacted by Innovation Norway with information about the amount.',
  },
  emailSetErrorMessage: {
    nb: 'Du må oppgi en e-postadresse',
    nn: 'Du må oppgi ei e-postadresse',
    en: 'You must provide an email address',
  },
  emailValidFormatErrorMessage: {
    nb: 'Du må oppgi en e-postadresse med gyldig format',
    nn: 'Du må oppgi ei e-postadresse med gyldig format',
    en: 'You must provide an email address in a valid format',
  },
  addPartnerButton: {
    nb: 'Legg til e-postadresse',
    nn: 'Legg til e-postadresse',
    en: 'Add email address',
  },
  optionalLabel: {
    nb: 'Valgfritt',
    nn: 'Valfritt',
    en: 'Optional',
  },
} as const;
